import React, { useEffect, useState } from 'react';
import { Card, CardBody, Button, Row, Col, Input, Spinner, Pagination, PaginationItem, PaginationLink, FormGroup, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import api, { FILE_BASE_URL } from '../../utils/api';

const ActivistsCards = () => {
  const [activists, setActivists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [country, setCountry] = useState('فلسطين');
  const [province, setProvince] = useState('');
  const [institution, setInstitution] = useState('');
  const [journalist, setJournalist] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    fetchActivists();
    fetchUserRole();
  }, [search, country, province, institution, journalist, page]);

  const fetchActivists = async () => {
    setLoading(true);
    try {
      const response = await api.get('/activists/cards', {
        params: {
          search,
          country,
          province,
          institution,
          journalist,
          page
        }
      });
      setActivists(response.data.data || []);
      setTotalPages(response.data.last_page || 1);
    } catch (error) {
      setActivists([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserRole = async () => {
    try {
      const response = await api.get('/user');
      setUserRole(response.data.role || '');
    } catch {
      setUserRole('');
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    if (selectedCountry !== 'فلسطين') {
      setProvince('');
    }
    setPage(1);
  };

  const countries = [
    'فلسطين', 'الأردن', 'لبنان', 'سوريا', 'مصر', 'السعودية', 'الإمارات', 'قطر', 
    'الكويت', 'العراق', 'المغرب', 'الجزائر', 'تونس', 'ليبيا', 'السودان', 'اليمن', 'عمان', 'البحرين', 'أخرى'
  ];

  const provinces = ['اريحا', 'الخليل', 'القدس', 'بيت لحم', 'جنين', 'رام الله', 'سلفيت', 'طوباس', 'طولكرم', 'غزة', 'قلقيلية', 'نابلس'];

  return (
    <div>
      <div className="d-flex align-items-center mb-4">
        <div 
          className="d-flex align-items-center justify-content-center rounded-circle me-3"
          style={{
            width: '50px',
            height: '50px',
            background: 'linear-gradient(135deg, #f46a6a 0%, #dc3545 100%)',
            color: 'white'
          }}
        >
          <i className="mdi mdi-account-heart mdi-24px"></i>
        </div>
        <div>
          <h4 className="card-title mb-1">بطاقات الناشطين</h4>
          <p className="text-muted mb-0">تصفح وابحث في الناشطين المسجلين</p>
        </div>
      </div>
      
      {/* Search Form */}
      <div 
        className="p-4 rounded mb-4"
        style={{ 
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          border: '1px solid #e3ebf0'
        }}
      >
        <Row className="g-3 align-items-end">
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-account-search me-2 text-warning"></i>
                الاسم
              </Label>
              <Input
                type="text"
                placeholder="🔍 ابحث بالاسم..."
                value={search}
                onChange={handleSearch}
                className="form-control-lg border-0 shadow-sm"
                style={{ borderRadius: '12px' }}
              />
            </div>
          </Col>
          
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-earth me-2 text-info"></i>
                الدولة
              </Label>
              <Input
                type="select"
                value={country}
                onChange={(e) => handleCountryChange(e.target.value)}
                className="form-control-lg border-0 shadow-sm"
                style={{ 
                  borderRadius: '12px',
                  paddingRight: '3rem'
                }}
              >
                <option value="">جميع الدول</option>
                {countries.map(country => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </Input>
            </div>
          </Col>

          {/* المحافظة - تظهر فقط إذا كانت الدولة فلسطين */}
          {country === 'فلسطين' && (
            <Col lg="2" md="6">
              <div className="position-relative">
                <Label className="form-label fw-semibold text-dark">
                  <i className="mdi mdi-map-marker me-2 text-success"></i>
                  المحافظة
                </Label>
                <Input
                  type="select"
                  value={province}
                  onChange={(e) => { setProvince(e.target.value); setPage(1); }}
                  className="form-control-lg border-0 shadow-sm"
                  style={{ 
                    borderRadius: '12px',
                    paddingRight: '3rem'
                  }}
                >
                  <option value="">جميع المحافظات</option>
                  {provinces.map(province => (
                    <option key={province} value={province}>{province}</option>
                  ))}
                </Input>
              </div>
            </Col>
          )}
          
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-office-building me-2 text-primary"></i>
                المؤسسة
              </Label>
              <Input
                type="text"
                placeholder="اسم المؤسسة..."
                value={institution}
                onChange={(e) => { setInstitution(e.target.value); setPage(1); }}
                className="form-control-lg border-0 shadow-sm"
                style={{ borderRadius: '12px' }}
              />
            </div>
          </Col>
          
          <Col lg="2" md="6">
            <div className="position-relative">
              <Label className="form-label fw-semibold text-dark">
                <i className="mdi mdi-account-tie me-2 text-success"></i>
                الصحفي المرتبط
              </Label>
              <Input
                type="text"
                placeholder="اسم الصحفي..."
                value={journalist}
                onChange={(e) => { setJournalist(e.target.value); setPage(1); }}
                className="form-control-lg border-0 shadow-sm"
                style={{ borderRadius: '12px' }}
              />
            </div>
          </Col>
          
          <Col lg={country === 'فلسطين' ? "2" : "4"} md="4">
            <Label className="form-label">&nbsp;</Label>
            <div className="d-flex gap-2">
              <Button 
                color="light" 
                onClick={() => {
                  setSearch('');
                  setCountry('فلسطين');
                  setProvince('');
                  setInstitution('');
                  setJournalist('');
                  setPage(1);
                }}
                disabled={loading}
                className="btn-lg shadow-sm"
                style={{ borderRadius: '12px' }}
                title="مسح الفلاتر"
              >
                <i className="mdi mdi-refresh text-primary"></i>
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      {loading ? (
        <div className="text-center"><Spinner color="primary" /></div>
      ) : activists.length === 0 ? (
        <div className="text-center">لا يوجد ناشطين</div>
      ) : (
        <Row>
          {activists.map((activist, idx) => (
            <Col md={3} className="mb-4" key={activist.id}>
              <Card style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.08)', borderRadius: '18px', overflow: 'hidden', border: 'none' }}>
                <div style={{ background: '#f5f6fa', padding: '24px 0 0 0', textAlign: 'center' }}>
                  {activist.profile_image ? (
                    <Link to={`/dashboard/activists/view/${activist.id}`}>
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${activist.profile_image}`}
                        alt={activist.full_name}
                        className="rounded-circle shadow"
                        style={{ width: '110px', height: '110px', objectFit: 'cover', border: '4px solid #7a6fbe', marginBottom: '-40px', background: '#fff', cursor: 'pointer' }}
                      />
                    </Link>
                  ) : (
                    <Link to={`/dashboard/activists/view/${activist.id}`}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white" style={{ width: '110px', height: '110px', fontSize: '38px', margin: '0 auto', border: '4px solid #7a6fbe', cursor: 'pointer' }}>
                        {activist.full_name?.charAt(0) || '؟'}
                      </div>
                    </Link>
                  )}
                </div>
                <CardBody style={{ paddingTop: '48px', textAlign: 'center' }}>
                  <h5 className="mb-2" style={{ color: '#7a6fbe', fontWeight: 'bold' }}>
                    <Link to={`/dashboard/activists/view/${activist.id}`} style={{ color: '#7a6fbe', textDecoration: 'underline', cursor: 'pointer' }}>
                      {activist.full_name}
                    </Link>
                  </h5>
                  <div style={{ color: '#555', fontSize: '15px', marginBottom: '8px' }}>
                    <i className="mdi mdi-map-marker text-primary me-1"></i>
                    {activist.city_or_area || '-'}
                  </div>
                  <div style={{ color: '#555', fontSize: '15px', marginBottom: '8px' }}>
                    <i className="mdi mdi-phone text-success me-1"></i>
                    {activist.mobile1 || '-'}
                  </div>
                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Link to={`/dashboard/activists/view/${activist.id}`}>
                      <Button color="success" size="sm" style={{ minWidth: '80px' }}>عرض</Button>
                    </Link>
                    {(userRole?.toLowerCase() === 'admin' || userRole?.toLowerCase() === 'data_entry') && (
                      <Link to={`/dashboard/activists/edit/${activist.id}`}>
                        <Button color="warning" size="sm" style={{ minWidth: '80px' }}>تحرير</Button>
                      </Link>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <div className="d-flex justify-content-center mt-4">
        <Pagination>
          {[...Array(totalPages)].map((_, i) => (
            <PaginationItem active={page === i + 1} key={i}>
              <PaginationLink onClick={() => setPage(i + 1)}>{i + 1}</PaginationLink>
            </PaginationItem>
          ))}
        </Pagination>
      </div>
    </div>
  );
};

export default ActivistsCards;
